export default __webpack_public_path__ + "static/media/statestreet.4b6a1048.svg";